import { Redis } from '@upstash/redis';

const redis = new Redis({
  url: 'https://global-settling-prawn-32315.upstash.io',
  token: 'AX47ACQgZjY2MDU0ZTQtNzljMS00YmMyLWE5Y2YtYTliNmQ1N2M2YTk5OGExNTZiM2FkZDk2NDc2NDgxYzFkOWQ3MjVmMWYxOTI=',
})

export default redis